export const createToastSlice = (set) => ({
    toasts: [],
    addToast: (message, type = "success", duration = 3000) => {
        const id = Date.now();
        set((state) => ({
            toasts: [...state.toasts, { id, message, type, duration }],
        }));
        // if duration is set to 0, don't remove automatically
        if (duration === 0)
            return;
        // Remove the toast after 3 seconds
        setTimeout(() => {
            set((state) => ({
                toasts: state.toasts.filter((toast) => toast.id !== id),
            }));
        }, duration);
    },
    removeToast: (id) => set((state) => ({
        toasts: state.toasts.filter((toast) => toast.id !== id),
    })),
});
